<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BmO5RG/tc-custom/9781913682699.jpg?1723836192941" alt="This image is the cover for the book Foul Trade, May Keaps Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Foul Trade, May Keaps Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Amid London’s docks and dark alleys, a coroner’s officer investigates a murder: </b><b>“A wonderful heroine . . . a side of the 1920s we don't usually see.” —Andrew Taylor, Diamond Dagger Award–winning author of <i>The King’s Evil</i></b><br/>  <br/> The poverty, drunken fights between visiting sailors, drug trafficking, and criminal gangs haunting the shadows of the busiest docks in the world mean that the Coroner sees more than its fair share of sudden and unnatural deaths. But Coroner’s Officer May Keaps has never failed to provide a jury with sufficient evidence to arrive at a just verdict.<br/><br/> May relishes the responsibility placed upon her—but there are many who believe it’s an unsuitable job for a woman. Even May begins to wonder if that’s the case when the discovery of a young man's body, in a Limehouse alley, plunges her into an underworld of opium dens, gambling, turf wars, protection rackets and murder—and she fears ending up on one of her own mortuary slabs…
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        BK Duncan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a57c8c2